export default __webpack_public_path__ + "static/media/01.1f718a43.jpg";